import { useEffect } from 'react'
import { stateRef, useStoreReducer } from './store'
import { loadTsgInstancesUsingCache, setOpen, setTsg, updateStateProps, getCurrentPortalDisplayAppId } from './actions'
import reducer from './reducer'
import { displayAppUrlPrefix, getUpdatedState } from './computed'
import { hooks, history, type AuthState } from '@sparky/framework'
import type { SwitcherStoreState, OpenTenantSwitcherEvent } from './store'

export { stateRef, type TsgAppInstances, type StateRef } from './store'
export * from './actions'

const DEFAULT_STATE = {
  disabled: false,
  isOpen: false,
} as Partial<SwitcherStoreState>

export const useSwitcherStoreState = (auth: AuthState) => {
  const state = useStoreReducer(reducer, DEFAULT_STATE, (state) => {
    return { ...state, ...getUpdatedState(auth) }
  })

  useEffect(() => {
    const newState = getUpdatedState(auth, stateRef)
    updateStateProps(newState)
  }, [auth])

  useEffect(() => {
    if (state.tsg) {
      loadTsgInstancesUsingCache(state.tsg)
    }
  }, [state.tsg])

  useEffect(() => {
    let lastPath = displayAppUrlPrefix()
    const unlisten = history.listen(() => {
      const curPath = displayAppUrlPrefix()
      if (curPath !== lastPath) {
        lastPath = curPath
        getCurrentPortalDisplayAppId()
      }
    })
    return unlisten
  }, [])

  hooks.useGlobalEventListener<OpenTenantSwitcherEvent>('open-tenant-switcher', ({ open = true, tsg_id } = {}) => {
    if (open && tsg_id) {
      setTsg(tsg_id)
    }
    setOpen(open)
  })

  return state
}
